import * as React from 'react'

import companies from 'modules/core/store/collections/companies'

import { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'

import ActivateCompanySlug from '../ActivateCompanySlug'
import ComplaintsManagerModal from './ComplaintsManagerModal'

interface Props {
  onSuccess: (payload?: ActivatePayload | null | undefined) => Promise<boolean>
  onClose: () => void
}

const ActivateComplaints = ({ onSuccess, onClose }: Props) => {
  const [showCompanyPageModal, setShowCompanyPageModal] = React.useState<boolean>(
    !companies.current.attributes.slug
  )

  const [showComplaintsManagerModal, setShowComplaintsManagerModal] = React.useState<boolean>(
    !showCompanyPageModal
  )

  const onActivateCompanySlugSuccess: (
    payload?: ActivatePayload | null | undefined
  ) => Promise<boolean> = async () => {
    setShowCompanyPageModal(false)
    setShowComplaintsManagerModal(true)
    return true
  }

  return (
    <>
      {showCompanyPageModal && (
        <ActivateCompanySlug onSuccess={onActivateCompanySlugSuccess} onClose={onClose} />
      )}
      {showComplaintsManagerModal && (
        <ComplaintsManagerModal onSuccess={onSuccess} onClose={onClose} />
      )}
    </>
  )
}

export default ActivateComplaints
